import CoreMenuHomePage from 'src/dispensary/core-menu/home';
import { getPrivateDispensaryServerSideProps } from 'src/utils/ssr/get-dispensary-server-side-props';
import { CoreMenuLayout } from 'components/layouts/core-menu-layout';
import { withLayout } from 'src/components/layouts/with-layout';

export const getServerSideProps = getPrivateDispensaryServerSideProps;

export default withLayout(CoreMenuHomePage, CoreMenuLayout);
